export default {
  login: "lee44",
  id: 13184429,
  node_id: "MDQ6VXNlcjEzMTg0NDI5",
  avatar_url: "https://avatars.githubusercontent.com/u/13184429?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/lee44",
  html_url: "https://github.com/lee44",
  followers_url: "https://api.github.com/users/lee44/followers",
  following_url: "https://api.github.com/users/lee44/following{/other_user}",
  gists_url: "https://api.github.com/users/lee44/gists{/gist_id}",
  starred_url: "https://api.github.com/users/lee44/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/lee44/subscriptions",
  organizations_url: "https://api.github.com/users/lee44/orgs",
  repos_url: "https://api.github.com/users/lee44/repos",
  events_url: "https://api.github.com/users/lee44/events{/privacy}",
  received_events_url: "https://api.github.com/users/lee44/received_events",
  type: "User",
  site_admin: false,
  name: "Lee",
  company: null,
  blog: "",
  location: "Los Angeles",
  email: null,
  hireable: true,
  bio: "B.S Degree in Computer Science from UC Santa Cruz",
  twitter_username: null,
  public_repos: 22,
  public_gists: 8,
  followers: 0,
  following: 0,
  created_at: "2015-07-05T08:37:41Z",
  updated_at: "2021-05-11T02:58:09Z",
};
